// Pages
import { purchaseMenu } from "configs/purchaseMenu"
import { salesMenu } from "configs/salesMenu"
import { ModuleLayout } from "../components"
import { accountsMenu, assetManagementMenu, cardsMenu, financeMenu, inventoryMenu } from "../configs"
import { assetManagementRoutes } from "./assetManagementRoutes"
import { accountsRoutes } from "./accountsRoutes"
import { cardsRoutes } from "./cardsRoutes"
import { financeRoutes } from "./financeRoutes"
import { inventoryRoutes } from "./inventoryRoutes"
import { purchaseRoutes } from "./purchaseRoutes"
import { salesRoutes } from "./salesRoutes"
import { tasksRoutes } from "./tasksRoutes"
import TaskList from "pages/Task/List"

// Utils
import { routeMapper } from "utils"
import { projectRoutes } from "./projectRoutes"

export const mainRoute = [
  {
    path: "/",
    element: <TaskList />
  },
  {
    path: "/accounts",
    element: <ModuleLayout menu={accountsMenu.menu} />,
    children: routeMapper(accountsRoutes)
  },
  {
    path: "/asset-management",
    element: <ModuleLayout menu={assetManagementMenu.menu} />,
    children: routeMapper(assetManagementRoutes)
  },
  {
    path: "/finance",
    element: <ModuleLayout menu={financeMenu.menu} />,
    children: routeMapper(financeRoutes)
  },
  {
    path: "/inventory",
    element: <ModuleLayout menu={inventoryMenu.menu} />,
    children: routeMapper(inventoryRoutes)
  },
  {
    path: "/cards",
    element: <ModuleLayout menu={cardsMenu.menu} />,
    children: routeMapper(cardsRoutes)
  },
  {
    path: "/sales",
    element: <ModuleLayout menu={salesMenu.menu} />,
    children: routeMapper(salesRoutes)
  },
  {
    path: "/purchase",
    element: <ModuleLayout menu={purchaseMenu.menu} />,
    children: routeMapper(purchaseRoutes)
  },
  {
    path: "/tasks",
    children: routeMapper(tasksRoutes)
  },
  {
    path: "/project",
    children: routeMapper(projectRoutes)
  },
]
